import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PageHeader.css";
import logo from "../assets/logo.png";

function PageHeader({ title, showBack = true, showLogo = false, actions, hideMenu = false }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const openProfile = () => {
    setMenuOpen(false);
    navigate("/profile");
  };

  return (
    <header className="page-header">
      <div className="page-header-inner">
        {showBack && (
          <button
            className="page-header-back"
            onClick={() => navigate("/dashboard")}
          >
            ‹ Back
          </button>
        )}
        <div className="page-header-brand">
          {showLogo && <img src={logo} alt="ABN Logo" className="page-header-logo" />}
          <h1 className="page-header-title">{title}</h1>
        </div>
        <div className="page-header-actions">
          {actions}
          {!hideMenu && <div className="page-header-menu-wrap">
            <button
              type="button"
              className="page-header-menu-button"
              aria-haspopup="menu"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((open) => !open)}
            >
              <span aria-hidden="true">☰</span>
              <span>Menu</span>
            </button>
            {menuOpen && (
              <div className="page-header-menu" role="menu">
                <button type="button" role="menuitem" onClick={openProfile}>Profile</button>
              </div>
            )}
          </div>}
        </div>
      </div>
    </header>
  );
}

export default PageHeader;
